/** Hyperbeat beHYPE — withdrawal enumeration on the WithdrawManager
 *  (`0x9d0b0877b9f2204cf414ca7862e4f03506822538`, HyperEVM 999,
 *  VERIFIED via Sourcify).
 *
 *  `getUserUnclaimedWithdrawals(user)` already returns only the
 *  open request ids; `withdrawalQueue(id)` gives the amounts and
 *  `canClaimWithdrawal(id)` the finalization flag. */
export const BeHypeWithdrawalAbi = [
  {
    name: 'getUserUnclaimedWithdrawals',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address', name: 'user' }],
    outputs: [{ type: 'uint256[]' }],
  },
  {
    name: 'canClaimWithdrawal',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'requestId' }],
    outputs: [{ type: 'bool' }],
  },
  {
    name: 'withdrawalQueue',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'requestId' }],
    outputs: [
      { name: 'user', type: 'address' },
      { name: 'beHypeAmount', type: 'uint256' },
      { name: 'hypeAmount', type: 'uint256' },
      { name: 'claimed', type: 'bool' },
    ],
  },
] as const
